export interface AnimationConfig {
  trigger: 'scroll' | 'hover' | 'click';
  duration: number;
  delay?: number;
  easing: 'easeOut' | 'easeIn' | 'easeInOut' | 'easeOutBack' | 'easeInBack' | 'easeOutElastic' | 'smooth' | 'snappy';
  pauseScroll?: boolean;
  pauseDuration?: number;
}

export interface ScrollAnimationVariants {
  hidden: {
    opacity: number;
    y?: number;
    x?: number;
    scale?: number;
  };
  visible: {
    opacity: number;
    y?: number;
    x?: number;
    scale?: number;
    transition: {
      duration: number;
      delay?: number;
      ease: string;
    };
  };
}

export const defaultAnimationConfig: AnimationConfig = {
  trigger: 'scroll',
  duration: 0.3,
  delay: 0,
  easing: 'easeOut',
  pauseScroll: false,
  pauseDuration: 200,
};

export const animationVariants = {
  fadeInUp: {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  },
  fadeInDown: {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0 }
  },
  fadeInLeft: {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0 }
  },
  fadeInRight: {
    hidden: { opacity: 0, x: 30 },
    visible: { opacity: 1, x: 0 }
  },
  fadeIn: {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  },
  scaleIn: {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 }
  }
} as const;

export type AnimationVariantName = keyof typeof animationVariants;